export default "__VITE_ASSET__CrEcCd8H__"